import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from '../../../../shared/common.service';
import * as CryptoJS from 'crypto-js';
import { AccountingpolicyService } from '../accountingpolicies/accountingpolicy.service';
import Swal from 'sweetalert2';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-accountingbasis-soletrader',
  templateUrl: './accountingbasis-soletrader.component.html',
  styleUrls: ['./accountingbasis-soletrader.component.scss']
})
export class AccountingbasisSoletraderComponent implements OnInit{
  APPeriodId: any;
  isJump: any;
  Basisdata: any
  AccountsTemplate: any
  Template: any;
  Accountingbasisform: FormGroup
  showBubbledata: any; disableDefaultButton: boolean
  clear:any
  constructor(public formbuilder: FormBuilder, public commonService: CommonService, private router: Router, private accountbasisservice: AccountingpolicyService, public sidenav: SideNavService) { }
 
  statement: string = "The accounts have been compiled on a basis that enables profits to be calculated in accordance with UK Generally Accepted Accounting Practice and that provides sufficient and relevant information to enable the completion of a tax return."

  ngOnInit() {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.commonService.getIncomeStatementsHeaders();
    //this.getAccountsTemplate();
    this.getaccountingbasis(this.APPeriodId);
    this.createaccountingbasis();
    this.commonService.getNotesData();
    this.commonService.Showbubble.subscribe((data) => {
      if (data) {
        this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data) => {
          this.commonService.showBubble = data[0].ImportStatus
          if (this.commonService.showBubble) {
            this.sidenav.setShowBubble(true);
            this.getlastyeardata()
          }
        })
      }
      else {
        this.showBubbledata = null
      }
    })
    this.clearfields();
    if (localStorage.getItem("SubmitStatus") == "true") {
      this.Accountingbasisform.disable()
      this.disableDefaultButton=true
    }
  }
  getDefaultStatements() {
    this.Accountingbasisform.controls["AccountingBasisAdditionalInformation"].setValue(this.statement);
  }

  clearfields() {
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        this.Accountingbasisform.reset()
      }
    })
  }

  createaccountingbasis() {
    this.Accountingbasisform = this.formbuilder.group({
      APPeriodId: new FormControl(),
      AccountingBasisId: new FormControl(),
      AccountingBasisAdditionalInformation: new FormControl(this.statement),
      CreatedBy: new FormControl(),
    })
  }

  insertaccountingbasis() {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.Accountingbasisform.controls['APPeriodId'].setValue(this.APPeriodId);
    this.Accountingbasisform.controls['CreatedBy'].setValue(localStorage.getItem('LoginuserId'))
    const formdata = this.Accountingbasisform.getRawValue();
    this.accountbasisservice.AddBasis(formdata).subscribe((data: any) => {
      this.Accountingbasisform.markAsPristine()
      if (this.NormalRoutng)
        return true
      var nextPage;
      nextPage = this.commonService.getNextNoteSelection("Accounting Basis", this.commonService.NotesList)
      if (this.isJump == 'true')
        this.router.navigate(['/notes'])
      else if (nextPage == 'accountingbasis') {
        nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
        this.router.navigate([nextPage]);
      }
      else {
        this.router.navigate([nextPage]);
      }
    })
  }
  save() {
    debugger
    if (this.validations()) {
      this.insertaccountingbasis();
    }
    else {
      this.NormalRoutng = false;
      return false;
    }
  }
  getaccountingbasis(APPeriodId) {
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.accountbasisservice.Getaccountingbasis(APPeriodId).subscribe((data: any) => {
      this.Accountingbasisform.patchValue(data);
      this.Basisdata=data
      if (this.Accountingbasisform.controls["AccountingBasisAdditionalInformation"].value == "" || this.Accountingbasisform.controls["AccountingBasisAdditionalInformation"].value == null) {
        this.Accountingbasisform.controls["AccountingBasisAdditionalInformation"].setValue(this.statement);
      }
    })
  }
  getlastyeardata() {
    this.accountbasisservice.GetaccountingbasisLY(this.APPeriodId).subscribe((data: any) => {
      this.showBubbledata = data;
    })
  }
  //getAccountsTemplate() {
  //  debugger
  //  var entityid = CryptoJS.AES.decrypt(localStorage.getItem("EntityId"), "APS").toString(CryptoJS.enc.Utf8)
  //  var legalformId = CryptoJS.AES.decrypt(localStorage.getItem("legalFormId"), "APS").toString(CryptoJS.enc.Utf8)
  //  this.commonService.getAccountingPeriod_AccountsTemplate(legalformId, entityid).subscribe((data:any) => {
  //    this.AccountsTemplate = data;
  //    this.Template = data.AccountsTemplateName;

  //    if (this.Template == "Sole Trader") {
  //      this.statement = "The accounts have been compiled on a basis that enables profits to be calculated in accordance with UK Generally Accepted Accounting Practice and that provides sufficient and relevant information to enable the completion of a tax return."
  //    } else {
  //      this.statement == ""
  //    }
  //  })
  //}
  totalback() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.router.navigate(['/business']);
  }
  NormalRoutng: boolean
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.Accountingbasisform.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight:900'>You have unsaved data. </span><br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.NormalRoutng = true;
          if(this.save())
            return true;
          else if (!this.NormalRoutng)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }
  back() {
    this.Accountingbasisform.markAsPristine();
    debugger
    var backpage;
    backpage = this.commonService.getBackSelection("Accounting Basis", this.commonService.NotesList)
    if (this.isJump == 'true')
      this.router.navigate(['/notes'])
    else if (backpage == 'accountingbasis') {
      this.router.navigate(['/notes']);
    }
    else {
      backpage = this.commonService.getBackSelection("Accounting Basis", this.commonService.NotesList)
      this.router.navigate([backpage]);
    }
  }

  validations() {
    if (this.Accountingbasisform.controls["AccountingBasisAdditionalInformation"].value == "" || this.Accountingbasisform.controls["AccountingBasisAdditionalInformation"].value == null) {
      Swal.fire("Andica Accounts Production", "Accounting basis cannot be left blank.", "warning")
      return false
    } else {
      return true
    }
  }


}
